<template>
  <v-card>
    <div class="running">
      <div class="running_area">
        <!-- <v-btn class="month_select" @click="prevMonth()">1개월</v-btn> -->
        <v-card class="mt-2">
          <v-row class="pt-2" no-gutters>
            <v-col cols="5">
              <v-menu
                v-model="isSDateView"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="startDate"
                    label="시작일"
                    dense
                    hide-details
                    outlined
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="startDate" @input="isSDateView = false" no-title></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="2" class="d-flex justify-center align-center">~</v-col>
            <v-col cols="5">
              <v-menu
                v-model="isEDateView"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    label="종료일"
                    dense
                    outlined
                    v-model="endDate"
                    hide-details
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="endDate" @input="isEDateView = false" no-title></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-btn
              class="look_btn"
              style="background-color: var(--v-btnbg-base); color: var(--v-cardtextbg-base)"
              @click="search"
            >조회</v-btn>
          </v-row>
        </v-card>
        <v-container fluid class="mt-4 ma-0 pa-0">
          <div id="realgrid" ref="realgrid" class="mb-5 w-full h-64"></div>
        </v-container>
      </div>
    </div>
  </v-card>
</template>

<script>
import { getBrokenRecord } from '@/api/pcs/siteWork'
import RealGridJS from 'realgrid/dist/main'

var gridView
var dataProvider
// var listCount = 0 //받은 정보 리스트 갯수
// var paegSize = 10 //한페이지당 보여주는 수
// var pageCount = 0 //총 페이지 갯수

export default {
  props: {
    SITE_ID: { type: String, default: '' },
    INVERTER_ID: { type: String, default: '' },
    STATION_ID: { type: String, default: '' }
  },
  data() {
    return {
      isSDateView: false,
      isEDateView: false,
      startDate: this.dateFormat(new Date()),
      endDate: this.dateFormat(new Date()),
      nowDate: this.$time(Date.now()).format('YYYY-MM-DD')
      // dateSel: this.$time(Date.now()).format("YYYY-MM-DD"),
      // timeSel: '00:00:00 01:00:00',
    }
  },
  created() {},
  mounted() {
    this.initGrid()
    this.prevMonth()
  },
  methods: {
    initGrid() {
      dataProvider = new RealGridJS.LocalDataProvider()
      gridView = new RealGridJS.GridView('realgrid')
      gridView.setDataSource(dataProvider)
      gridView.setRowIndicator({
        visible: false
      })

      // gridView에 옵션을 적용한다.
      gridView.setOptions({
        panel: {
          visible: false
        },
        stateBar: {
          visible: false
        },
        checkBar: {
          visible: false
        },
        indicator: {
          visible: false
        },
        footer: {
          visible: false
        },
        edit: {
          // 데이터 편집
          appendable: false,
          insertable: false,
          deletable: false,
          readOnly: true
        },
        header: {
          // gridView 헤더 설정
          height: 30,
          styles: {
            fontSize: '14',
            fontFamily: 'NanumGothic',
            foreground: '#fff',
            fontBold: 'false',
            background: '#5c97cd',
            selectedBackground: '#9bb2c7',
            borderLeft: '#fff',
            borderRight: '#fff'
          },
          selection: {
            background: '#efefef',
            border: '#ccc,1'
          }
        },
        display: {
          // 그리드 표시 정보 설정
          fitStyle: 'even', // 컬럼 너비 자동 조절
          heightMeasurer: 'fixed',
          rowHeight: 30,
          focusVisible: false, // 클릭시 포커스
          showEmptyMessage: true,
          emptyMessage: '조회된 정보가 없습니다.'
        },
        sorting: {
          handleColor: '#fff', // 필터된 헤더 화살표 색상
          hoveredHandleColor: '#fff'
        },
        select: {
          style: 'none' // 선택시 스타일
        }
      })

      // gridView.setStyles({
      //   // gridView 스타일
      //   body: {
      //     fontSize: '14',
      //     fontFamily: 'NanumGothic',
      //     foreground: '#666',
      //     fontBold: 'false',
      //     borderLeft: '#fff,0',
      //     borderRight: '#ccc,1',
      //     borderBottom: '#ccc,1',
      //     empty: {
      //       textAlignment: 'center',
      //       lineAlignment: 'center',
      //       fontSize: 14,
      //       fontBold: false
      //     },
      //     dynamicStyles: [
      //       {
      //         criteria: '(row mod 2) = 0',
      //         styles: {
      //           background: '#F4F4FA'
      //         }
      //       }
      //     ]
      //   }
      // })
      gridView.setDisplayOptions({
        emptyMessage: '',
        fitStyle: true,
        focusVisible: false
      })

      var fields = [
        { fieldName: 'Date', dataType: 'string' },
        { fieldName: 'Time', dataType: 'string' },
        { fieldName: 'Inverter_No', dataType: 'string' },
        { fieldName: 'Run_Status', dataType: 'string' }
      ]
      var columns = [
        {
          name: 'Date',
          fieldName: 'Date',
          header: {
            text: '일자'
          },
          styles: {
            textAlignment: 'center'
          }
        },
        {
          name: 'Time',
          fieldName: 'Time',
          header: {
            text: '시간'
          },
          styles: {
            textAlignment: 'center'
          },
          width: 60
        },
        {
          name: 'Inverter_No',
          fieldName: 'Inverter_No',
          header: {
            text: '인버터 번호'
          },
          styles: {
            textAlignment: 'center'
          }
        },
        {
          name: 'Run_Status',
          fieldName: 'Run_Status',
          header: {
            text: '고장 이력'
          },
          styleName: 'text-left',
          width: 250
        }
      ]
      dataProvider.setFields(fields)
      gridView.setColumns(columns)

      /* //컬럼(이력)에서 특정값에 따라 아이콘 변경
      var imageUrl = "http://" + location.host + "/external/runImage/";
      var imgs = new RealGridJS.ImageList("images1", imageUrl);
      imgs.addUrls(["running_green.png", "running_red.png"]);
      gridView.registerImageList(imgs);
      //이미지 리스트에서 사용할 이름 설정
      gridView.setColumnProperty("Run_Status", "imageList", "images1");
      //아이콘 타입의 렌더러 설정
      gridView.setColumnProperty("Run_Status", "renderer", { type: "icon" });
      //아이콘 적용 설정
      var iconSet = this.$refs.realgrid.clientWidth / 8 - 27;
      gridView.setColumnProperty("Run_Status", "styles", {
        iconIndex: 0,
        iconLocation: "left",
        iconAlignment: "center",
        iconOffset: iconSet,
        iconPadding: 8
      });
      //dynamictStyles 생성
      var iconStyles = [
        {
          criteria: "value='RUN'",
          styles: "iconIndex=0"
        },
        {
          criteria: "value='STOP'",
          styles: "iconIndex=1"
        }
      ];
      gridView.setColumnProperty("Run_Status", "dynamicStyles", iconStyles); */
      window.scrollTo(0, 0)
    },

    prevMonth() {
      // 날짜선택
      this.endDate = this.dateFormat(new Date())
      this.startDate = this.dateFormat(
        new Date().setDate(new Date().getDate() - 6)
      )
    },
    dateFormat(d) {
      const _day = new Date(d)
      const year = _day.getFullYear()
      const mon =
        (_day.getMonth() + 1).toString().length === 1
          ? '0'.toString(1) + (_day.getMonth() + 1)
          : _day.getMonth() + 1
      const da =
        _day.getDate().toString().length === 1
          ? '0'.toString(1) + _day.getDate()
          : _day.getDate()
      console.log(year + '-' + mon + '-' + da)
      return year + '-' + mon + '-' + da
    },

    search() {
      if (this.startDate === '' || this.startDate == null) {
        alert('시작일을 선택해 주세요')
        return
      } else if (this.endDate === '' || this.endDate == null) {
        alert('종료일을 선택해 주세요')
        return
      }

      var day = this.$time(this.endDate, 'YYYY-MM-DD').diff(
        this.$time(this.nowDate, 'YYYY-MM-DD'),
        'days'
      )
      var dayReage = this.$time(this.endDate, 'YYYY-MM-DD').diff(
        this.$time(this.startDate, 'YYYY-MM-DD'),
        'days'
      )
      if (day > 0) {
        alert('조회 불가능 날짜입니다.')
        return
      } else if (dayReage > 31) {
        alert('조회기간은 최대 31일까지 입니다.')
        return
      }

      let params = ''
      var sDate = this.$time(this.startDate).format('YYYY-MM-DD')
      var eDate = this.$time(this.endDate).format('YYYY-MM-DD')
      if (this.INVERTER_ID === null || this.INVERTER_ID === '') {
        params =
          '/' + this.SITE_ID + '/' + sDate + '/' + eDate + '/' + 0 + '/' + 0
      } else {
        params =
          '/' +
          this.SITE_ID +
          '/' +
          sDate +
          '/' +
          eDate +
          '/' +
          this.INVERTER_ID +
          '/' +
          this.STATION_ID
      }
      console.log('param', params)
      let config = {
        message: 'Load Data...',
        styleName: 'fontSize-18'
      }
      gridView.showToast(config)
      getBrokenRecord(params).then(response => {
        // RealGrid에 조회한 데이터를 넣는다.
        // let temp = []
        // // console.log(res.brokenRecord.length)
        // for (let i = 1; i < response.brokenRecord.length; i++) {
        //   if (
        //     response.brokenRecord[i - 1].Run_Status !==
        //     response.brokenRecord[i].Run_Status
        //   ) {
        //     temp.push(response.brokenRecord[i - 1])
        //   }
        // }
        // temp.push(response.brokenRecord[response.brokenRecord.length - 1])
        // dataProvider.fillJsonData(temp)
        dataProvider.fillJsonData(response.brokenRecord)
        console.log('result', response.brokenRecord)

        gridView.hideToast()
      })
    }
  },
  beforeDestroy: function() {
    // 데이터 초기화
    dataProvider.clearRows()

    // grid, provider 초기화
    gridView.destroy()
    dataProvider.destroy()

    // LocalDataProvider와 GridView 객체 초기화
    gridView = null
    dataProvider = null
  }
}
</script>

<style lang="scss" scoped>
// @import '../../../assets/mobile/site.less';
#realgrid {
  height: 100vw;
}

.boxSize {
  text-align: center;
  width: 100%;
  height: 8.4vw;
  padding: 1.5vw;
}
.boxSize input {
  text-align: center;
}
.timeSelect {
  width: 100%;
  background: #ededed;
  padding-top: 1.5vw;
  padding-left: 6vw;
  padding-right: 3vw;
  color: #666;
  font-family: 'hhiLight', 'Avenir', Helvetica, Arial, sans-serif;
  font-size: 4.2vw;
  font-weight: bold;
}
.headerStyle {
  color: red;
}
.running_area {
  margin-top: 0;
}
.fontSize-18 {
  font-size: 32px;
}
</style>
